import script from "./left-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./left-bottom.vue?vue&type=script&setup=true&lang=js"

import "./left-bottom.vue?vue&type=style&index=0&id=d38c0806&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d38c0806"]])

export default __exports__